import { render, staticRenderFns } from "./smartRampIcon.vue?vue&type=template&id=2ac001f0&scoped=true"
var script = {}
import style0 from "./smartRampIcon.vue?vue&type=style&index=0&id=2ac001f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac001f0",
  null
  
)

export default component.exports